module.exports = __webpack_public_path__ + "static/media/pdf-poster.53fea2b8.jpg";